{
  "list": {
    "title": "Invoices",
    "create": "Create Invoice",
    "createExtra": "Add-on sale",
    "searchPlaceholder": "Search by invoice code, payer name, or student name — no need to type accents",
    "client": "Client",
    "dueDate": "Due Date",
    "amount": "Amount",
    "status": "Status",
    "kind": "Type",
    "kindClose": "Close-month",
    "kindManual": "Manual",
    "kindTerm": "Course",
    "loading": "Loading invoices...",
    "loadError": "Could not load invoices. Try again.",
    "emptyTeachTitle": "No invoices yet",
    "emptyTeachBody": "Invoices are generated when you close out the month — once attendance is done, you can close it.",
    "emptyFilterTitle": "No invoices match this filter",
    "searchHint": "Search by invoice code, payer name, or student name — no need to type accents.",
    "unknownClient": "Unknown Client",
    "filterAll": "All",
    "subtitleTotal": "{{count}} invoices",
    "subtitleTotal_one": "{{count}} invoice",
    "subtitlePending": "{{count}} pending",
    "subtitleOverdue": "{{count}} overdue",
    "subtitleEmpty": "No invoices yet",
    "filterGroupLabel": "Filter by status",
    "overdueSuffix": "{{count}} days late",
    "overdueSuffix_one": "{{count}} day late",
    "selectRow": "Select invoice {{code}}",
    "sortNewest": "Newest first",
    "sortOldest": "Oldest first",
    "sortAmountDesc": "Amount: High to low",
    "sortAmountAsc": "Amount: Low to high",
    "window": {
      "monthPickerLabel": "Pick a different month",
      "reset": "Back to this month"
    },
    "searchResults": "{{count}} results for “{{q}}” — accents optional",
    "searchResults_one": "{{count}} result for “{{q}}” — accents optional"
  },
  "detail": {
    "loading": "Loading invoice details...",
    "notFound": "Invoice not found",
    "backToList": "Back to Invoices",
    "invoiceTitle": "Invoice {{code}}",
    "publicLink": "Public Link",
    "publicLinkHiddenImpersonating": "Hidden while impersonating — opening this link marks the invoice as viewed by the client, and that cannot be undone.",
    "edit": "Edit",
    "delete": "Delete",
    "deleteConfirm": "Are you sure you want to delete this invoice? This action cannot be undone.",
    "client": "Client",
    "details": "Details",
    "created": "Created",
    "dueDate": "Due Date",
    "sepayTxn": "SePay Txn ID",
    "lineItems": "Line Items",
    "description": "Description",
    "qty": "Qty",
    "unitPrice": "Unit Price",
    "total": "Total",
    "subtotal": "Subtotal",
    "tax": "Tax ({{rate}}%)",
    "depositPaid": "Deposit Paid",
    "balanceDue": "Balance Due",
    "grandTotal": "Total",
    "notes": "Notes / Terms",
    "sendInvoice": "Send invoice",
    "sendReminder": "Send reminder",
    "publicViewedAt": "Client viewed at",
    "paidAt": "Paid at",
    "lastPaymentAt": "Latest payment",
    "autoMatchedShort": "Auto-matched transfer",
    "manualMarked": "Marked by hand",
    "paySource": {
      "CASH": "Cash",
      "MANUAL_BANK": "External bank transfer",
      "ECOMMERCE": "E-commerce",
      "OTHER": "Other",
      "SEPAY": "SePay"
    },
    "lastReminderSentAt": "Last reminder sent",
    "markPaid": "Mark as paid",
    "copyLink": "Copy link",
    "qrConsequence": "When a parent transfers using this QR, the invoice flips to Paid on its own — nothing more for you to do.",
    "qrDepositNote": "This invoice has a deposit — send the link so the parent can pay the remaining balance."
  },
  "sendDialog": {
    "title": {
      "send": "Send invoice to client",
      "reminder": "Send payment reminder"
    },
    "subtitle": {
      "send": "Choose how to send the invoice to the client.",
      "reminder": "Choose how to remind the client to pay."
    },
    "drafting": "Drafting content...",
    "draftFailed": "AI couldn't draft, please type manually",
    "field": {
      "to": "Send to",
      "subject": "Subject",
      "body": "Body"
    },
    "cancel": "Cancel",
    "close": "Close",
    "send": "Send",
    "sending": "Sending...",
    "toast": {
      "sent": "Invoice sent",
      "reminded": "Reminder sent",
      "error": "Something went wrong"
    },
    "tabs": {
      "manual": "Send manually",
      "auto": "Auto via Zalo",
      "email": "Email",
      "emailDisabledHint": "Client has no email on file — use the Send manually tab to send via Zalo or QR code instead."
    },
    "manual": {
      "messageLabel": "Message content",
      "copyMessage": "Copy message",
      "messageCopied": "Message copied",
      "messageCopyFailed": "Couldn't copy the message",
      "editTemplatePrefix": "Edit the message template in",
      "editTemplateLinkLabel": "Settings"
    },
    "auto": {
      "comingSoon": "Coming soon — automatically send invoices via Zalo ZNS."
    },
    "zalo": {
      "linkLabel": "Public invoice link",
      "copy": "Copy",
      "copied": "Link copied",
      "copyFailed": "Couldn't copy the link",
      "qrLabel": "VietQR payment code",
      "paymentRef": "Transfer content",
      "markSharedAction": "Mark as sent",
      "markedToast": "Marked as sent",
      "reminderHint": "Copy the message or QR code to remind the client.",
      "qrShare": "Share",
      "qrCopy": "Copy image",
      "qrCopied": "Image copied",
      "qrDownload": "Download",
      "qrActionFailed": "Couldn't get the QR image — try again",
      "nothingToCollect": "This invoice has nothing left to collect — no QR code or Zalo send needed."
    },
    "qrError": {
      "loading": "Generating QR code...",
      "bankNotLinked": "No bank account linked.",
      "unsupportedBank": "This bank isn't supported for VietQR yet.",
      "linkBank": "Link bank account",
      "retry": "Retry"
    }
  },
  "form": {
    "title": "Create Invoice",
    "titleExtra": "Create Add-on Invoice",
    "titleEdit": "Edit Invoice",
    "invoiceDetails": "Invoice Details",
    "client": "Client *",
    "selectClient": "Select a client",
    "clientSearchPlaceholder": "Search by name or phone...",
    "clientEmpty": "No client found",
    "dueDate": "Due Date *",
    "selectDate": "Select date",
    "lineItems": "Products / Services",
    "addItem": "Add Product/Service",
    "description": "Description",
    "descriptionPlaceholder": "Textbook, study kit...",
    "qty": "Qty",
    "negativeQtyHint": "Enter a negative quantity to deduct from the invoice, e.g. tuition already collected outside the app.",
    "unitPrice": "Unit Price (VND)",
    "lineTotal": "Line total",
    "additionalInfo": "Additional Info",
    "notes": "Notes / Payment Terms",
    "notesPlaceholder": "Thank you for your business...",
    "summary": "Summary",
    "subtotal": "Subtotal",
    "taxRate": "Tax Rate (%)",
    "taxAmount": "Tax Amount",
    "total": "Total",
    "cancel": "Cancel",
    "submit": "Create Invoice",
    "submitting": "Creating...",
    "submitEdit": "Save changes",
    "savingEdit": "Saving...",
    "selectClientAlert": "Please select a client",
    "editLockedToast": "Only draft invoices can be edited",
    "fromClosingBadge": "From closing",
    "fromClosingTooltip": "This item was generated by month-end closing — it can't be edited or deleted to keep reconciliation in sync. Only supplementary items can be added or changed.",
    "negativeTotalError": "The total is negative because the deduction exceeds the invoice — reduce the deducted quantity or add an item so the total is no longer negative.",
    "manualOnClosingHint": "Hand-added lines are not part of next month’s adjustment. If the session count is wrong because the schedule was wrong, fix the schedule, delete this draft and run closing again; add lines only for non-tuition charges or money already collected elsewhere."
  },
  "status": {
    "DRAFT": "Draft",
    "SENT": "Sent",
    "PENDING": "Pending",
    "PARTIAL": "Partial",
    "PAID": "Paid",
    "OVERDUE": "Overdue",
    "CANCELLED": "Cancelled"
  },
  "bulk": {
    "bar": {
      "summary": "{{count}} invoices selected · Total {{total}}",
      "markPaid": "Mark as paid ({{eligible}}/{{count}})",
      "delete": "Delete drafts ({{draft}}/{{count}})",
      "dueDate": "Edit due date ({{draft}}/{{count}})",
      "clear": "Clear selection",
      "selectAll": "Select all",
      "ariaLabel": "Bulk actions on selected invoices"
    },
    "markPaidDialog": {
      "title": "Mark as paid",
      "description": "{{eligible}} invoices will be marked as paid.",
      "descriptionWithSkipped": "{{eligible}} invoices will be marked as paid, {{skipped}} will be skipped (already paid or cancelled).",
      "source": "Payment source",
      "cancel": "Cancel",
      "confirm": "Mark as paid",
      "confirming": "Processing..."
    },
    "deleteDialog": {
      "title": "Delete draft invoices",
      "description": "{{eligible}} draft invoices will be permanently deleted. This action cannot be undone.",
      "descriptionWithSkipped": "{{eligible}} draft invoices will be permanently deleted, {{skipped}} non-draft invoices will be skipped. This action cannot be undone.",
      "cancel": "Cancel",
      "confirm": "Delete {{eligible}} invoices",
      "confirming": "Deleting..."
    },
    "dueDateDialog": {
      "title": "Edit due date",
      "description": "{{eligible}} draft invoices will have their due date updated.",
      "descriptionWithSkipped": "{{eligible}} draft invoices will have their due date updated, {{skipped}} non-draft invoices will be skipped.",
      "label": "New due date",
      "past": "The due date must be today or later.",
      "cancel": "Cancel",
      "confirm": "Update {{eligible}} invoices",
      "confirming": "Updating..."
    },
    "toast": {
      "markPaidSuccess": "Marked {{count}} invoices as paid",
      "markPaidSuccessWithSkipped": "Marked {{count}} invoices as paid ({{skipped}} skipped)",
      "markPaidError": "Couldn't mark the selected invoices, try again",
      "deleteSuccess": "Deleted {{count}} draft invoices",
      "deleteSuccessWithSkipped": "Deleted {{count}} draft invoices ({{skipped}} skipped)",
      "deleteError": "Couldn't delete the selected invoices, try again",
      "dueDateSuccess": "Updated the due date on {{count}} invoices",
      "dueDateSuccessWithSkipped": "Updated the due date on {{count}} invoices ({{skipped}} skipped)",
      "dueDateError": "Couldn't update the due date, try again",
      "viewLog": "View in log"
    }
  },
  "autoMatch": {
    "today": "Auto-matched transfer at {{time}} today",
    "on": "Auto-matched transfer at {{time}} on {{date}}"
  },
  "reviewTargets": {
    "title": "Review for {{month}} · the month you just taught"
  }
}
